import React from 'react';

import exclamationTriangleSvg from '../../../assets/images/exclamation-triangle.svg';
import inputClearSvg from '../../../assets/images/input-clear.svg';
import searchSubmitSvg from '../../../assets/images/search-submit.svg';

export function SearchSubmitIcon({ className = '' }) {
  return (
    <img
      src={searchSubmitSvg}
      alt="Search"
      className={`h-5 w-5 ${className}`}
      title="Search"
    />
  );
}

export function LoadingIndicator() {
  return (
    <span
      aria-hidden="true"
      className="pointer-events-none inset-y-0 right-3 flex items-center"
      data-testid="loading-indicator"
    >
      <span className="inline-block h-4 w-4 animate-spin rounded-full border border-gray-300 border-t-gray-500" />
    </span>
  );
}

export function ExclamationTriangleIcon({ className = '' }) {
  return (
    <img
      src={exclamationTriangleSvg}
      alt="Error"
      className={`h-5 w-5 ${className}`}
      title="Error"
    />
  );
}

export function ClearIcon({ className = '' }) {
  return (
    <img
      src={inputClearSvg}
      alt="Clear input"
      className={`h-3.5 w-3.5 text-gray-90 ${className}`}
      title="Clear input"
    />
  );
}

export function CheckIcon({ className = '' }) {
  return (
    <svg
      className={`h-5 w-5 ${className}`}
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
      data-testid="check-icon"
    >
      <path
        fillRule="evenodd"
        d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function MapPin({ className = '' }) {
  return (
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      aria-hidden="true"
    >
      <title>Current Location</title>
      <g>
        <path
          fill="#0202ea"
          d="M10 20c-0.153 0-0.298-0.070-0.393-0.191-0.057-0.073-1.418-1.814-2.797-4.385-0.812-1.513-1.46-2.999-1.925-4.416-0.587-1.787-0.884-3.472-0.884-5.008 0-3.308 2.692-6 6-6s6 2.692 6 6c0 1.536-0.298 3.22-0.884 5.008-0.465 1.417-1.113 2.903-1.925 4.416-1.38 2.571-2.74 4.312-2.797 4.385-0.095 0.121-0.24 0.191-0.393 0.191zM10 1c-2.757 0-5 2.243-5 5 0 3.254 1.463 6.664 2.691 8.951 0.902 1.681 1.809 3.014 2.309 3.71 0.502-0.699 1.415-2.040 2.318-3.726 1.223-2.283 2.682-5.687 2.682-8.935 0-2.757-2.243-5-5-5z"
        />
        <path
          fill="#0202ea"
          d="M10 9c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zM10 4c-1.103 0-2 .897-2 2s0 .897 2 .897c1 .897 .897-.897 .897-.897s-.897-.897-.897-.897z"
        />
      </g>
    </svg>
  );
}
